//import appLocaleData from 'react-intl/locale-data/nl';
import saMessages from '../locales/nl_NL.json';

const saLang = {
  messages: {
    ...saMessages
  },
  locale: 'nl-NL'
  //data: appLocaleData
};
export default saLang;
